/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { ReactNode } from 'react'
import { Text } from '@mantine/core'

export type WidgetProps<T extends ReactNode> = {
  label: string,
  value?: T
}

function Widget<T extends ReactNode> (props: WidgetProps<T>) {
  const { label, value } = props
  return (
    <div>
      <Text c="dimmed">
        {label}
      </Text>
      <div>
        {value != null ? value : '-'}
      </div>
    </div>
  )
}

export default Widget
